/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrganizationIdBaseDto from './OrganizationIdBaseDto';
import PermissionDto from './PermissionDto';

/**
 * The RoleDto model module.
 * @module model/RoleDto
 * @version v1.0.0
 */
class RoleDto {
    /**
     * Constructs a new <code>RoleDto</code>.
     * @alias module:model/RoleDto
     */
    constructor() { 
        
        RoleDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RoleDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RoleDto} obj Optional instance to populate.
     * @return {module:model/RoleDto} The populated <code>RoleDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RoleDto();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('organization')) {
                obj['organization'] = OrganizationIdBaseDto.constructFromObject(data['organization']);
            }
            if (data.hasOwnProperty('permissions')) {
                obj['permissions'] = ApiClient.convertToType(data['permissions'], [PermissionDto]);
            }
            if (data.hasOwnProperty('priority')) {
                obj['priority'] = ApiClient.convertToType(data['priority'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * role description
 * @member {String} description
 */
RoleDto.prototype['description'] = undefined;

/**
 * role id
 * @member {Number} id
 */
RoleDto.prototype['id'] = undefined;

/**
 * role name
 * @member {String} name
 */
RoleDto.prototype['name'] = undefined;

/**
 * @member {module:model/OrganizationIdBaseDto} organization
 */
RoleDto.prototype['organization'] = undefined;

/**
 * permission list
 * @member {Array.<module:model/PermissionDto>} permissions
 */
RoleDto.prototype['permissions'] = undefined;

/**
 * Priority
 * @member {Number} priority
 */
RoleDto.prototype['priority'] = undefined;






export default RoleDto;

